export function initCitySearch() {
    const citiesModal = document.querySelector('#citiesModal');

    if (citiesModal) {
        citiesModal.addEventListener('input', function (event) {
            const citySearchInput = event.target;

            if (citySearchInput.id === 'citySearch') {
                let query = citySearchInput.value.trim();

                // Проверяем, есть ли уже элемент для списка результатов
                let resultList = document.getElementById('cityResults');

                if (!resultList) {
                    // Создаем ul для результатов
                    resultList = document.createElement('ul');
                    resultList.id = 'cityResults';
                    // Вставляем список результатов сразу после инпута
                    citySearchInput.insertAdjacentElement('afterend', resultList);
                }

                if (query.length > 1) {
                    fetch('/local/ajax/searchCity.php?q=' + query)
                        .then(response => response.json())
                        .then(data => {
                            resultList.innerHTML = ''; // Очищаем предыдущие результаты

                            if (data.success && data.cities.length > 0) {
                                // Обновляем список городов
                                data.cities.forEach(city => {
                                    let listItem = document.createElement('li');
                                    let link = document.createElement('a');
                                    link.href = city.URL;
                                    link.classList.add("js-change-city")
                                    link.textContent = city.NAME + ', ' + city.REGION;
                                    link.dataset.id = city.ID
                                    link.dataset.subdomain = city.HAS_SUB
                                    listItem.appendChild(link);
                                    resultList.appendChild(listItem);
                                });
                            } else {
                                resultList.innerHTML = '<li>Города не найдены</li>';
                            }
                        })
                        .catch(error => console.error('Ошибка:', error));
                } else {
                    resultList.innerHTML = ''; // Очищаем список, если запрос короткий
                }
            }
        });
    }
}
